import { render, staticRenderFns } from "./numCell.vue?vue&type=template&id=a061b3b8&scoped=true"
import script from "./numCell.vue?vue&type=script&lang=js"
export * from "./numCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a061b3b8",
  null
  
)

export default component.exports